// src/data/fullReportDetails.js
const reportDetail = {
  id: "medical",
  title: "Medical Report",
  offer: "20% OFF",
  features: [
    "Expert Astrologers",
    "Personalized Solutions",
    "24/7 Support"
  ],
  shortDescription: "Understanding Kundali involves finding the Ascendant, understanding the 12 houses representing different facets of life, and noting the planetary positions in each house to gain insights into one’s destiny and qualities of life",
  longDescription: `Medical astrology is the branch of astrology where we can predict the type of diseases and during which dasha/antardasha it will be more effective. Generally, the sixth house is responsible for the nature of diseases, but while calculating the diseases, we have to check many factors such as the strength of the ascendant lord, the First house, and the Karak of the first house, which is the Sun, as well as aspects of malefic planets on the ascendant lord. Different planets give different types of diseases; for instance, the Sun is the karak of immunity and bones, whereas the Moon is the karak of the mind. If the Moon and Sun are both afflicted in the horoscope, then the chances of disease will increase. In our report, we have clearly mentioned 2100 conditions of disease which shall impact you, either highly or lowly. On the last page, we have mentioned the remedies.`,
  image: "/images/cd_img.png",
  sampleReportLink: "#",
  viewReportLink: "#",
  downloadReportLink: "#"
}

export default reportDetail